import script from "./AdministratorDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./AdministratorDetail.vue?vue&type=script&setup=true&lang=js"

import "./AdministratorDetail.vue?vue&type=style&index=0&id=53ff4bae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53ff4bae"]])

export default __exports__